import React from 'react';

function isValidUrl(url) {
    const pattern = /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i;
    return pattern.test(url);
}

function parseTextWithLinks(text) {
    let parsedText = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, (match, title, url) => {
        if (isValidUrl(url)) {
            return `<a target="_blank" href="${url}">${title}</a>`;
        } else {
            return match;
        }
    });

    const lines = parsedText.split('\n');
    let result = '';
    let inList = false;

    for (let line of lines) {
        const trimmedLine = line.trim();

        if (trimmedLine.startsWith('•') || trimmedLine.startsWith('*')) {
            if (!inList) {
                result += '<ul>';
                inList = true;
            }
            const listItem = trimmedLine.substring(1).trim();
            result += `<li>${listItem}</li>`;
        } else if (trimmedLine.startsWith('- ')) {
            if (inList) {
                result += '</ul>';
                inList = false;
            }
            result += `<div>${trimmedLine}</div>`;
        } else if (trimmedLine && inList) {
            result = result.replace(/<\/li>$/, ` ${trimmedLine}</li>`);
        } else {
            if (inList) {
                result += '</ul>';
                inList = false;
            }
            if (trimmedLine) {
                result += `<p>${trimmedLine}</p>`;
            }
        }
    }

    if (inList) {
        result += '</ul>';
    }

    return result;
}

function TextWithLinksParser({ text }) {
    const parsedText = parseTextWithLinks(text);
    return <div dangerouslySetInnerHTML={{ __html: parsedText }} />;
}

export default TextWithLinksParser;
